/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Row, Col, Input, Form, Button, Table, Spin, message } from "antd";
import "./style.scss";
import API from "../../../api";
import urls from "../../../api/urls";
import { capitalize, commonSorterForTable, serialNum } from "../../../utils";
import Heading from "../../../components/Heading";
import { useLocation, useNavigate } from "react-router-dom";
import UpdateIcon from "../../../assests/images/updateEway.svg";
import { useParams } from "react-router-dom";
import { hubEwayData } from "../../../store/hubEway";
import whiteUpdateIcon from "../../../assests/images/whiteUpdateEway.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import search_icon from "../../../assests/images/search-icon.svg";
import useCustomNavigate from "../../../components/customNavigationHook";

const {
  HUBEWAYBILL,
  CONSOLIDATE_EWAY_BILL,
  EWAYBILL_UPDATE_PARTB,
  AUDIT_EWAY_BILL,
  UPDATED_EWAY_BILL,
} = urls;

const HubEWayBill = () => {
  const [form] = Form.useForm();
  const params = useParams();
  const history = useLocation();
  const navigate = useCustomNavigate();
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [dataSource, setdataSource] = useState(tableData);

  const [inputSearchValue, setInputSearchValue] = useState("");
  const userId = JSON.parse(localStorage.getItem("userId"));
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [updatedEwayData, setUpdatedEwayData] = useState([]);
  const [transPortMode, setTransPortMode] = useState("surface");

  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  let vehicleNumber =
    history?.state?.state?.vehicleNum || history?.state?.state?.flightNum;
  let driverName = history?.state?.state?.driverName;

  function getModifiedGST(item) {
    const gstNumber = item?.premises?.gst;
    const firstTwoDigits = gstNumber?.substring(0, 2);
    const modifiedDigits = firstTwoDigits?.startsWith("0")
      ? firstTwoDigits?.substring(1)
      : firstTwoDigits;
    return modifiedDigits;
  }

  const columns = [
    {
      title: "SI No",
      dataIndex: "",
      key: "SI",
      width: 15,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      width: 10,
    },
    {
      title: "AWb No",
      dataIndex: "awbNumber",
      key: "awbNumber",
      width: 40,
      render: (text) => {
        return text;
      },
    },
    {
      title: "E-way Bill No",
      width: 30,
      dataIndex: "ewayBillNumber",
      key: "ewayBillNumber",
    },
    {
      title: "Destination Hub",
      dataIndex: "toHub",
      key: "toHub",
      width: 40,
      sorter: (a, b) => commonSorterForTable(a, b, "toHub"),
      sortOrder: sortedInfo?.columnKey === "toHub" ? sortedInfo?.order : null,
      ellipsis: true,
      render: (record, _data) => {
        return capitalize(record);
      },
    },
    {
      title: "Mode",
      width: 40,
      dataIndex: "travelBy",
      key: "travelBy",
      render: (record, _data) => {
        return capitalize(record);
      },
    },

    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      width: 60,
      render: (data, record) => {
        return (
          <div>
            {record?.ewayUpdated ? (
              <Button
                className=""
                // disabled={record?.ewayUpdated}
                style={{
                  borderRadius: "5px",
                  color: "white",
                  background: "#149D11",
                  cursor: "not-allowed",
                }}
              >
                <img src={whiteUpdateIcon} />
                <span className="ml-1 fw-500">E-WAY BILL UPDATED</span>
              </Button>
            ) : (
              <Button
                className=""
                // disabled={record?.ewayUpdated}
                style={{
                  borderRadius: "5px",
                  color: "#2E77D0",
                  background: "white",
                }}
                onClick={() => SingleConsolidate(record)}
              >
                <img src={UpdateIcon} />
                <span className="ml-1 fw-500">E-WAY BILL UPDATE</span>
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "/" + mm + "/" + yyyy;

  useEffect(() => {
    getUpdatedEwayBills();
  }, []);

  useEffect(() => {
    getEwayBills();
  }, [updatedEwayData]);

  const getUpdatedEwayBills = async () => {
    setLoading(true);
    let response = await API.Api(
      `${UPDATED_EWAY_BILL}${params?.id}`
    ).getWithAllHeaders();
    if (response?.status) {
      setLoading(false);
      setUpdatedEwayData(response?.response?.data?.ewaybill);
    } else {
      setLoading(false);
    }
  };

  function printShipmentAwbNumbers(data) {
    const modifiedData = [];
    data?.stopLcrs?.forEach((stopLcr) => {
      const viewLCREwayShipment = stopLcr?.viewLCREwayShipment;
      viewLCREwayShipment?.shipmentLists?.forEach((shipment) => {
        if (shipment?.ewayBillNumber) {
          const ewayBillNumbers = shipment?.ewayBillNumber?.split(",");
          ewayBillNumbers.forEach((billNumber) => {
            modifiedData.push({
              ...shipment,
              awbNumber: shipment?.awbNumber || shipment?.childBarcode,
              ewayBillNumber: billNumber.trim(),
              tripId: data?.tripId,
              toHub: viewLCREwayShipment?.toHub,
              travelBy: viewLCREwayShipment?.travelBy?.toLowerCase(),
            });
          });
        }
      });
    });

    const groupedData = modifiedData.reduce((result, item) => {
      const existingItem = result.find(
        (el) => el.ewayBillNumber === item.ewayBillNumber
      );
      if (existingItem) {
        existingItem.awbNumber;
      } else {
        result.push({ ...item });
      }
      return result;
    }, []);

    return groupedData;
  }

  // let data = {
  //   vehicleLcrId: 20244009271,
  //   tripId: "BENGALURU-19-1002",
  //   vehicleNum: "KA23VB7845",
  //   fromPremise: 19,
  //   status: "LOCKED",
  //   stopLcrs: [
  //     {
  //       id: 3253,
  //       lcrNum: 7297739137,
  //       viewLCRGeneration: null,
  //       viewLCREwayShipment: {
  //         lcrNum: 7297739137,
  //         fromDate: "2024-01-09 16:41:09",
  //         toDate: "09/01/2024",
  //         fromHub: "WILSON GARDEN HUB",
  //         toHub: "BENGALURU HEBBAL HUB",
  //         fromPremiseId: 19,
  //         toPremiseId: 38,
  //         travelBy: "Surface",
  //         coloader: "own",
  //         vehicleNum: "KA23VB7845",
  //         driverName: "Sagar Kumar",
  //         shipmentLists: [
  //           {
  //             awbNumber: 23019250069147,
  //             ewayBillNumber: "131739779807,131739779807,191739779876",
  //             bookingStatus: "HUB-OUTSCAN",
  //             ewayBillCreateDate: "09-01-2024 16:31:19",
  //             expiryDate: "09-01-2024 16:31:19",
  //             bookingCompleteTime: "09-01-2024 16:31:19",
  //             value: "70019.0",
  //           },

  //           {
  //             awbNumber: 23019200114338,
  //             ewayBillNumber: "131761608441",
  //             bookingStatus: "HUB-OUTSCAN",
  //             ewayBillCreateDate: "09-01-2024 16:31:40",
  //             expiryDate: "09-01-2024 16:31:40",
  //             bookingCompleteTime: "09-01-2024 16:31:40",
  //             value: "671809.0",
  //           },
  //         ],
  //         createdDate: "09-01-2024 16:41:09",
  //         updatedDate: null,
  //       },
  //       vehicleLcrId: 20244009271,
  //       reached: false,
  //     },
  //   ],
  //   createdDate: "09-01-2024 16:40:10",
  //   updatedDate: "09-01-2024 16:41:12",
  //   loadCapacity: 2000,
  //   removeWeight: null,
  //   utilization: 61.1,
  //   totalutilizations: [61.1],
  //   totalRemoveweight: null,
  // };

  const getEwayBills = async (e) => {
    setLoading(true);
    let response = await API.Api(HUBEWAYBILL + params?.id).getWithAllHeaders();
    if (response) {
      setLoading(false);
      const temp = response?.response?.data?.data;
      const getShipments = printShipmentAwbNumbers(temp);
      for (let i = 0; i < getShipments?.length; i++) {
        if (updatedEwayData?.includes(getShipments[i]?.ewayBillNumber)) {
          getShipments[i].ewayUpdated = true;
        } else {
          getShipments[i].ewayUpdated = false;
        }
      }

      setTableData(getShipments);
      setTransPortMode(getShipments[0]?.travelBy == "surface" ? "1" : "3");
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message);
    }
  };

  const handleSubmit = async (params) => {
    setLoading(true);

    const stateGST = getModifiedGST(userId);

    if (selectedRowKeys?.length > 0) {
      let temp = selectedRowKeys?.map((val) => {
        return { ewbNo: val };
      });

      let payload = {
        fromPlace: userId?.premises?.city,
        fromState: +stateGST,
        vehicleNo: vehicleNumber,
        transMode: transPortMode,

        transDocDate: params?.transDocDate, //same format
        tripSheetEwbBills: temp,
      };
      let response = await API.Api(CONSOLIDATE_EWAY_BILL).postIdHeader(payload);

      if (response?.response?.data?.status == "1") {
        setLoading(false);
        message.success(
          response?.response?.data?.message || "E-way Bill Updated Successfully"
        );
        auditEwayBill(response?.response?.data, selectedRowKeys, "consolidate");
        setSelectedRowKeys([]);
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.data || "Failed to Update E-way bill"
        );
      }
    } else {
      message.error("Select an E-way bill");
      setLoading(false);
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: record.ewayUpdated,
      name: record.name,
    }),
    selectedRowKeys: selectedRowKeys,
  };

  const SingleConsolidate = async (params) => {
    setLoading(true);
    const stateGST = getModifiedGST(userId);

    let payload = {
      ewbNo: params?.ewayBillNumber,
      vehicleNo: vehicleNumber,
      fromPlace: userId?.premises?.city,
      fromState: +stateGST,
      transDocDate: formattedToday,
      transMode: transPortMode,
    };
    let response = await API.Api(
      EWAYBILL_UPDATE_PARTB + params?.ewayBillNumber + "/partB"
    ).patchIdHeader(payload);
    if (response?.response?.data?.status == "1") {
      setLoading(false);
      message.success(
        response?.response?.data?.message || "E-way Bill Updated Successfully"
      );
      auditEwayBill(response?.response?.data, params, "single");
    } else {
      setLoading(false);
      message.error(
        response?.response?.data?.data || "Failed to Update E-way bill"
      );
    }
  };

  async function auditEwayBill(singleUpdateRes, record, type) {
    setLoading(true);

    function filterDataByAwbNumbers(dataArray, awbNumbersArray) {
      return dataArray?.filter((item) =>
        awbNumbersArray?.includes(item?.ewayBillNumber)
      );
    }
    let temp = [];
    let payload = {};
    if (type == "single") {
      temp = tableData?.filter(
        (val) => val?.ewayBillNumber === record?.ewayBillNumber
      );
      payload = {
        shipments: temp?.map((val) => {
          return {
            ewbBillExpDate: val?.expiryDate,
            awbcrtDate: val?.bookingCompleteTime,
            ewaybillNo: val?.ewayBillNumber,
            ewayBillCrtDate: val?.ewayBillCreateDate || null,
            shipmentValue: val?.value,
            awbnumber: val?.awbNumber,
          };
        }),
        tripid: params?.id,
        consEwbNo: "0",
        vehicleNo: vehicleNumber,
        transMode: transPortMode == "1" ? "surface" : "air",
        ewbOprPlace: userId?.premises?.city,
      };
    } else {
      let filteredData = filterDataByAwbNumbers(tableData, record);

      let temp = singleUpdateRes?.data;
      let cNum = JSON.parse(temp);

      payload = {
        shipments: filteredData?.map((val) => {
          return {
            awbnumber: val?.awbNumber,
            ewaybillNo: val?.ewayBillNumber,
            ewayBillCrtDate: val?.ewayBillCreateDate || null,
            ewbBillExpDate: val?.expiryDate,
            awbcrtDate: val?.bookingCompleteTime,
            shipmentValue: val?.value,
          };
        }),
        tripid: params?.id,
        consEwbNo: cNum?.cEwbNo,
        vehicleNo: vehicleNumber,
        transMode: transPortMode == "1" ? "surface" : "air",
        ewbOprPlace: userId?.premises?.city,
      };
    }

    const response = await API.Api(AUDIT_EWAY_BILL).postIdHeader(payload);

    if (response.status) {
      setLoading(false);
      getUpdatedEwayBills();
    } else {
      setLoading(false);
    }
  }
  const finishBtnHandler = () => {
    if (history?.state?.slug === "/lcr-generation") {
      navigate(history?.state?.slug, {
        state: {
          page: "2",
          key: "HUB_EWAY_BILL",
        },
      });
    } else {
      navigate(history?.state?.slug);
    }
  };

  const filterArray = (data, currValue) => {
    return data?.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(currValue?.toLowerCase())
      )
    );
  };

  const onSearch = (e) => {
    const currValue = e.target.value;
    setInputSearchValue(currValue);

    const filteredData =
      inputSearchValue?.length > 0 || inputSearchValue?.length == 0
        ? filterArray(tableData, currValue)
        : filterArray(tableData, currValue);
    setdataSource(filteredData);
  };

  return (
    <Spin
      spinning={loading}
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div className="m-2">
        <Heading title={"Hub E-way Bill"} />
        <div className="hub-eway-container p-2">
          <Form
            form={form}
            onFinish={handleSubmit}
            name="accountBasicDetails"
            layout="vertical"
            initialValues={{
              transDocDate: formattedToday,
              tripLCRID: params?.id,
              driverName: driverName || "",
              vehicleNo: vehicleNumber,
            }}
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
          >
            {tableData?.length ? (
              <>
                <Row justify="center" gutter={16} className="m-1">
                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      // initialValue={"bottom"}
                      name="transDocDate"
                      label="Date"
                      rules={[
                        {
                          required: false,
                          message: "Select Date",
                        },
                      ]}
                    >
                      <Input placeholder="Date" disabled />
                    </Form.Item>
                  </Col>

                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      name="tripLCRID"
                      label="Trip LCR ID"
                      rules={[
                        {
                          required: true,
                          message: "Enter Trip LCR ID",
                        },
                      ]}
                    >
                      <Input placeholder="Enter Trip LCR ID" disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row justify="center" gutter={16} className="m-1">
                  <Col span={8} sm={24} md={8} lg={8} xs={24}>
                    <Form.Item
                      name="vehicleNo"
                      label={
                        transPortMode == "1"
                          ? "Vehicle number"
                          : "Flight number"
                      }
                      rules={[
                        {
                          required: true,
                          message: "Enter vehicle number",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter vehicle number"
                        defaultValue={vehicleNumber}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  {transPortMode == "1" ? (
                    <Col span={8} sm={24} md={8} lg={8} xs={24}>
                      <Form.Item
                        name="driverName"
                        label="Driver name"
                        rules={[
                          {
                            required: true,
                            message: "Enter Driver name",
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Driver name"
                          defaultValue={driverName}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <Col span={8} sm={24} md={8} lg={8} xs={24}></Col>
                  )}
                </Row>
              </>
            ) : (
              <Row justify="end mb-2">
                <h2 style={{ margin: "auto" }}>No E-way bills present</h2>
              </Row>
            )}
          </Form>
        </div>
        <div className="p-2 hub-eway-container">
          <Row justify="space-between">
            <Input
              placeholder="Search by AWB, Eway number"
              bordered
              onChange={onSearch}
              style={{
                borderRadius: "5px",
                height: "40px",
                maxWidth: "250px",
                marginBottom: "20px",
              }}
              suffix={<img src={search_icon} />}
            />
            <Button
              className="save-btn"
              htmlType="submit"
              onClick={form.submit}
            >
              CONSOLIDATE UPDATE
            </Button>
          </Row>
          <Table
            onChange={handleChange}
            columns={columns}
            scroll={{ x: 500 }}
            dataSource={inputSearchValue?.length == 0 ? tableData : dataSource}
            pagination={false}
            rowKey={(record) => record?.ewayBillNumber}
            rowSelection={{
              ...rowSelection,
            }}
          />
        </div>

        {/* <Row justify="end mt-2">
          <Button className="save-btn" onClick={finishBtnHandler}>
            NEXT
          </Button>
        </Row> */}
      </div>
    </Spin>
  );
};
export default HubEWayBill;
